import { UserStatus, Cookie } from '@nuxt-common/util/app/utils/cookie';

export const createHeaders = ({ isUOP = true, ssrCookies = null, userAgent = null } = {}) => {
  const headers = {
    'x-requested-with': 'XMLHttpRequest',
    ...(ssrCookies && { cookie: ssrCookies }),
    ...(userAgent && { 'User-Agent': userAgent }),
  };

  if (isUOP) headers['X-Macys-ClientId'] = 'ordermodsreturns';

  if (import.meta.server && ssrCookies) {
    const uidMatch = ssrCookies.match(/X-Macys-UID=([^;]+)/);
    if (uidMatch) {
      headers['X-Macys-UID'] = uidMatch[1];
    }
  } else if (!import.meta.server && UserStatus.isSignedIn()) {
    const uid = Cookie.getSessionId();
    if (uid) headers['X-Macys-UID'] = encodeURIComponent(uid);
  }

  return { headers };
};
